import React from "react";
import AppRoutes from "../src/routes/routes";
import "./responsive.css";

const App = () => {
  return <AppRoutes />;
};

export default App;